import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ACTIONS_DROPDOWN: `${cleanedFilename(__filename)}-actions-dropdown`,
};
